var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckCircleIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_21029",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 68,
    height: 68
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 68,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_21029)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.9244 45.0718L48.0468 26.9494L46.0417 24.9442L29.9244 41.0615L21.8494 32.9865L19.8442 34.9917L29.9244 45.0718ZM34.0095 59.5C30.4833 59.5 27.168 58.8309 24.0638 57.4927C20.9595 56.1544 18.2593 54.3382 15.9629 52.044C13.6667 49.7499 11.8488 47.0521 10.5093 43.9508C9.16975 40.8494 8.5 37.5357 8.5 34.0095C8.5 30.4833 9.16912 27.168 10.5073 24.0638C11.8456 20.9595 13.6618 18.2593 15.956 15.9629C18.2501 13.6667 20.9479 11.8488 24.0492 10.5093C27.1506 9.16975 30.4643 8.5 33.9905 8.5C37.5167 8.5 40.832 9.16911 43.9362 10.5073C47.0405 11.8456 49.7407 13.6618 52.0371 15.956C54.3333 18.2501 56.1512 20.9479 57.4907 24.0492C58.8302 27.1506 59.5 30.4643 59.5 33.9905C59.5 37.5167 58.8309 40.832 57.4927 43.9362C56.1544 47.0405 54.3382 49.7407 52.044 52.0371C49.7499 54.3333 47.0521 56.1512 43.9508 57.4907C40.8494 58.8302 37.5357 59.5 34.0095 59.5ZM34 56.6667C40.3278 56.6667 45.6875 54.4708 50.0792 50.0792C54.4708 45.6875 56.6667 40.3278 56.6667 34C56.6667 27.6722 54.4708 22.3125 50.0792 17.9208C45.6875 13.5292 40.3278 11.3333 34 11.3333C27.6722 11.3333 22.3125 13.5292 17.9208 17.9208C13.5292 22.3125 11.3333 27.6722 11.3333 34C11.3333 40.3278 13.5292 45.6875 17.9208 50.0792C22.3125 54.4708 27.6722 56.6667 34 56.6667Z",
    fill: "#AC772B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleIc);
export default __webpack_public_path__ + "static/media/check_circle_ic.ec091a6509295583ffa2ccf646513acf.svg";
export { ForwardRef as ReactComponent };